module.exports = __webpack_public_path__ + "img/92.971fa6c7.jpg";